export default __webpack_public_path__ + "static/media/teleaffecticon.81178a72.png";